import { Controller } from '@hotwired/stimulus'

const TRANSITION_MS = 200

export default class extends Controller {
  static targets = ['dialog', 'panel']

  connect() {
    this.isOpen = false
    this.boundKeydown = this.handleKeydown.bind(this)
  }

  disconnect() {
    document.removeEventListener('keydown', this.boundKeydown)
    this.#unlockScroll()
    if (this.closeTimeout) clearTimeout(this.closeTimeout)
  }

  open(event) {
    event?.preventDefault()
    if (!this.hasDialogTarget) return
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout)
      this.closeTimeout = null
    }

    this.isOpen = true
    this.dialogTarget.classList.remove('hidden')
    this.dialogTarget.classList.add('flex')
    this.dialogTarget.setAttribute('aria-hidden', 'false')
    this.#lockScroll()
    document.addEventListener('keydown', this.boundKeydown)

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.dialogTarget.classList.remove('opacity-0')
        this.dialogTarget.classList.add('opacity-100')
        if (this.hasPanelTarget) {
          this.panelTarget.classList.remove(
            'opacity-0',
            'scale-95',
            'translate-y-2'
          )
          this.panelTarget.classList.add(
            'opacity-100',
            'scale-100',
            'translate-y-0'
          )
        }
      })
    })
  }

  close() {
    if (!this.hasDialogTarget || !this.isOpen) return

    this.isOpen = false
    document.removeEventListener('keydown', this.boundKeydown)

    this.dialogTarget.classList.remove('opacity-100')
    this.dialogTarget.classList.add('opacity-0')
    if (this.hasPanelTarget) {
      this.panelTarget.classList.remove(
        'opacity-100',
        'scale-100',
        'translate-y-0'
      )
      this.panelTarget.classList.add(
        'opacity-0',
        'scale-95',
        'translate-y-2'
      )
    }

    this.closeTimeout = setTimeout(() => {
      this.dialogTarget.classList.add('hidden')
      this.dialogTarget.classList.remove('flex')
      this.dialogTarget.setAttribute('aria-hidden', 'true')
      this.#unlockScroll()
      this.closeTimeout = null
    }, TRANSITION_MS)
  }

  closeBackdrop(event) {
    if (event.target === this.dialogTarget) {
      this.close()
    }
  }

  handleKeydown(event) {
    if (!this.isOpen) return

    if (event.key === 'Escape') {
      event.preventDefault()
      this.close()
    }
  }

  #lockScroll() {
    document.body.classList.add('overflow-hidden')
  }

  #unlockScroll() {
    document.body.classList.remove('overflow-hidden')
  }
}
